import { useEffect, useState } from "react";
import SuperSideBar from "./Compo/SuperSideBar";
import { baseurl } from "../../Baseurl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SuperAllOrganization() {
  const [organizations, setOrganizations] = useState([]);

  // Filters
  const [searchName, setSearchName] = useState("");
  const [employeeFilter, setEmployeeFilter] = useState("");
  const [hasWebsite, setHasWebsite] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllOrganizations`);
        if (res.data && res.data.organizations) {
          setOrganizations(res.data.organizations);
        }
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
        toast.error("Failed to load organizations.");
      }
    };

    fetchOrganizations();
  }, []);

  const filteredOrganizations = organizations.filter((org) => {
    const matchesName = org.name?.toLowerCase().includes(searchName.toLowerCase());

    const matchesEmployee = employeeFilter
      ? org.employee_size === employeeFilter
      : true;

    const matchesWebsite =
      hasWebsite === "yes"
        ? org.website && org.website.trim() !== ""
        : hasWebsite === "no"
        ? !org.website || org.website.trim() === ""
        : true;

    const createdDate = new Date(org.created_at);
    const matchesDate =
      (!startDate || createdDate >= new Date(startDate)) &&
      (!endDate || createdDate <= new Date(endDate));

    return matchesName && matchesEmployee && matchesWebsite && matchesDate;
  });

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <SuperSideBar />
        <div className="superwidth" style={{ flexGrow: 1, padding: "20px" }}>
          <div className="px-4">
            <div className="container-fluid">
              <div className="mt-4">
                <h2 className="chart-title text-start">All Organization</h2>

                {/* Filter Section */}
                <div className="row g-2 mb-3">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-filter"
                      placeholder="Search by name"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2">
                    <select
                      className="form-control form-control-filter"
                      value={employeeFilter}
                      onChange={(e) => setEmployeeFilter(e.target.value)}
                    >
                      <option value="">All Employee Sizes</option>
                      <option value="1-10">1-10</option>
                      <option value="11-50">11-50</option>
                      <option value="51-200">51-200</option>
                      <option value="201-500">201-500</option>
                      <option value="500+">500+</option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <select
                      className="form-control form-control-filter"
                      value={hasWebsite}
                      onChange={(e) => setHasWebsite(e.target.value)}
                    >
                      <option value="">All Websites</option>
                      <option value="yes">With Website</option>
                      <option value="no">Without Website</option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control form-control-filter"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2">
                    <input
                      type="date"
                      className="form-control form-control-filter"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-1">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() => {
                        setSearchName("");
                        setEmployeeFilter("");
                        setHasWebsite("");
                        setStartDate("");
                        setEndDate("");
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                {/* Table Section */}
                <div className="table-responsive">
                  <table className="custom-table">
                    <thead className="table-dark">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Created At</th>
                        <th>Employee Size</th>
                        <th>Website</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOrganizations.length > 0 ? (
                        filteredOrganizations.map((org) => (
                          <tr key={org.id}>
                            <td>{org.id}</td>
                            <td>{org.name}</td>
                            <td>{new Date(org.created_at).toLocaleDateString()}</td>
                            <td>{org.employee_size || "N/A"}</td>
                            <td>
                              {org.website ? (
                                <a href={org.website} target="_blank" rel="noreferrer">
                                  {org.website}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No organizations found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </>
  );
}

export default SuperAllOrganization;
